import { IconButton } from 'src/styles/button.style';
import styled from 'styled-components';

type Props = {
    isRotationMenuCollapsed?: boolean;
};

type DynamicSizeProps = {
    containerHeight?: number;
    containerWidth?: number;
};

export const StowagePageWrapper = styled.div`
    display: flex;
    flex-direction: right;
    height: 100%;
    overflow: hidden;
    width: 100%;
    background: ${({ theme }) => theme.colors.background.white};
    color: ${({ theme }) => theme.colors.text.black};

    .splitter-vertical {
        height: 5px;
        cursor: row-resize;
        z-index: 1;
        &:hover {
            cursor: row-resize;
        }
    }

    .splitter-horizontal {
        width: 2px;
        cursor: row-resize;
        z-index: 1;
        &:hover {
            cursor: row-resize;
        }
    }
`;

export const RotationViewWrapper = styled.div<Props>`
    height: calc(100% - 5px);
    margin: 0 5px 5px;
    display: flex;
    position: relative;
    box-shadow: ${({ theme }) => theme.colors.stowage.rotationView.shadow} 0 2px 6px 2px;
    flex: 0.5;
`;

export const RotationContainerWrapper = styled.div<Props>`
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export const RotationMenuWrapper = styled.div<Props>`
    height: 100%;
    width: 5px;
    position: relative;
`;

export const RightViewWrapper = styled.div<DynamicSizeProps>`
    height: ${(props) => (props.containerHeight ? props.containerHeight + 'px' : '100%')};
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
    margin: 0 5px 5px 0;
    background: ${({ theme }) => theme.colors.background.white};
    box-shadow: ${({ theme }) => theme.colors.stowage.rightView.shadow} 0 2px 6px 2px;

    .resize-root-wrapper {
        @media only screen and (min-width: 3000px) {
            grid-template-columns: auto 10px auto !important;
            grid-template-rows: auto !important;
        }
    }
`;

export const PortalWrapper = styled.div`
    height: 100%;
    width: 100%;
`;

export const TankPlanViewWrapper = styled.div<DynamicSizeProps>`
    height: ${(props) => (props.containerHeight ? props.containerHeight + 'px' : '100%')};
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
    box-shadow: ${({ theme }) => theme.colors.stowage.tankPlanView.shadow} 0px 2px 6px 2px;
    margin: 0;
    padding: 0;
`;

export const CargoOperationsViewWrapper = styled.div<DynamicSizeProps>`
    height: ${(props) => (props.containerHeight ? props.containerHeight + 'px' : '100%')};
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
    margin: 0;
    padding: 0;
`;

export const BottomViewWrapper = styled.div<DynamicSizeProps>`
    height: 100%;
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
    @media only screen and (min-width: 3840px) {
        flex: 2;
    }
`;

export const OperationListViewWrapper = styled.div<DynamicSizeProps>`
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
    padding: 5px 0 0 0;
    height: calc(100% - 72px);
    &.tab-visible {
        display: block;
    }
    &.tab-hidden {
        display: none;
    }
`;

export const ViolationListViewWrapper = styled.div`
    height: calc(100% - 72px);
    padding: 5px 0 0 0;
    &.tab-visible {
        display: block;
    }
    &.tab-hidden {
        display: none;
    }
`;

export const CollapseRotationMenu = styled.button`
    position: absolute;
    top: 15px;
    right: 5px;
    background: none;
    border: 0;
    font-size: 1rem;
`;

export const PopOutButton = styled(IconButton)`
    margin: 0px 5px 0px -2px;
    border: 1px solid ${({ theme }) => theme.colors.stowage.popOutButton.border};
    border-bottom: 0;
    padding: 0 8px;
    height: 50px;

    :hover {
        border: 1px solid ${({ theme }) => theme.colors.stowage.popOutButton.border};
    }
    .red-icon {
        top: -8px;
        right: -8px;
    }
`;

export const RotationHeader = styled.div`
    background: ${({ theme }) => theme.colors.background.white};
    border-bottom: 2px solid ${({ theme }) => theme.colors.brand.darkBlue};
    height: 60px;
    padding: 10px 15px;
    margin: 0px 0px 2px;
    display: flex;
    gap: 45px;
    align-items: center;
    overflow: hidden;
`;

export const TankplanFilters = styled.ul`
    .dd-item {
        display: flex;
        flex-direction: column;
        margin: 0 0 10px 0;
        padding: 5px;
        width: 100%;
        select {
            width: 100%;
        }
    }
`;

export const NoStowagePlansMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666;
    font-style: italic;
    padding: 20px;
    text-align: center;
`;
